'use strict';

/* Filters */
angular.module('app').filter('stopTimeCalculation', function() {
    return function(startTime, endTime) {
        if (!endTime) {
            return '-';
        }

        var start = moment.utc(startTime, 'YYYY-MM-DD HH:mm:ss');
        var end = moment.utc(endTime, 'YYYY-MM-DD HH:mm:ss');
        var duration = moment.utc(end.diff(start));

        return duration.format('HH:mm:ss');
    };
});

function getDateWithIsoFormat(dateString) {
    if (dateString === undefined) {
        return new Date();
    }
    var t = dateString.split(/[- :]/);
    var date = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));
    return date;
}
